import React from "react";
import Header from "../header";
import DefaultFooter from "../defaultFooter";
import s from "./Layout.module.scss";
import "@styles/index.scss";
import { MenuProvider } from "../../context/MenuStore";
const Layout = _ref => { let { children, customFooter } = _ref; return /*#__PURE__*/ React.createElement(MenuProvider, null, /*#__PURE__*/ React.createElement("div", { className: s.wrap }, /*#__PURE__*/ React.createElement(Header, null), /*#__PURE__*/ React.createElement("div", { className: s.body }, children), customFooter ? customFooter() : /*#__PURE__*/ React.createElement(DefaultFooter, null))); };
export default Layout;
